import React, { useEffect, useState } from "react";
import { Link } from "react-router";
import { isValidEmail, isValidName, isValidPhoneNumber } from "./Utils";
import { QUERY_FORM_URL, REQUEST_URL } from "./Config";

function Footer() {
  //email newsletter state
  const [emailDetails, setEmailDetails] = useState({
    emailID: "",
    isValidEmail: false,
  });

  //contact us form data state
  const [contactUSDetails, setContactUSDetails] = useState({
    customer_name: "",
    customer_email: "",
    customer_phone: "",
    customer_query: "",
  });

  //submit newsletter form button clicked state
  const [submitClicked, setSubmitClicked] = useState(false);
  //submit contact us form button clicked state
  const [submitContactUSClicked, setSubmitContactUSClicked] = useState(false);
  //contact us form details validity
  const [contactUSValidity, setContactUSValidity] = useState({
    isValidName: true,
    isValidEmail: true,
    isValidPhoneNumber: true,
    isValidQuery: true,
  });

  //use effect
  //use effect to handle the submit newsletter button click
  useEffect(() => {
    // If the submit button was clicked
    if (submitClicked === true) {
      //check if valid email id
      if (isValidEmail(emailDetails.emailID)) {
        //api call add to email list
        newsLetterEmailAPI(emailDetails.emailID);

        console.log("Call newsletter api");
      }
    }
    //check if contact us clicked
    if (submitContactUSClicked === true) {
      //set validity
      setContactUSValidity({
        ...contactUSValidity,
        isValidName: isValidName(contactUSDetails.customer_name),
        isValidEmail: isValidEmail(contactUSDetails.customer_email),
        isValidPhoneNumber: isValidPhoneNumber(contactUSDetails.customer_phone),
        isValidQuery:
          contactUSDetails.customer_query.length > 10 ? true : false,
      });

      //check
      if (
        isValidName(contactUSDetails.customer_name) &&
        isValidEmail(contactUSDetails.customer_email) &&
        (contactUSDetails.customer_query.length > 10 ? true : false)
      ) {
        //call api
        queryEmailSubmitAPI();
        //check
        console.log("Call contact us form api");
      } else {
        //rest submit click
        setSubmitContactUSClicked(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitClicked, submitContactUSClicked]);

  //on input newsletter email field changed
  const onInputNewsletterEmailFieldChanged = (e) => {
    //check
    setEmailDetails({
      ...emailDetails,
      isValidEmail: isValidEmail(e.target.value),
      emailID: e.target.value,
    });
  };

  //on contact us form value changed
  const onContactUSFormValueChanged = (e) => {
    //set values
    setContactUSDetails({ ...contactUSDetails, [e.target.id]: e.target.value });
  };

  //submit handler for the form
  const onSubmitNewsletterForm = (event) => {
    // Get the textarea value
    event.preventDefault();
    //set the submit clicked state to true
    //can not access the form values directly here
    //as the state is not updated immediately
    //use effect will be called after the state is updated
    setSubmitClicked(true);
  };

  //submit handler for the form
  const onSubmitContactUSForm = (event) => {
    // Get the textarea value
    //event.preventDefault();
    //set the submit clicked state to true
    //can not access the form values directly here
    //as the state is not updated immediately
    //use effect will be called after the state is updated
    setSubmitContactUSClicked(true);
  };

  //submit query api call
  const queryEmailSubmitAPI = async () => {
    //get the access token from local storage
    var accessToken = localStorage.getItem("access_token");
    accessToken =
      accessToken !== null && accessToken !== "undefined" ? accessToken : "";

    //fetch the humanized text from the API
    await fetch(QUERY_FORM_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // if needed
      },
      body: JSON.stringify({
        full_name: contactUSDetails.customer_name,
        email_id: contactUSDetails.customer_email,
        phone_number: isValidPhoneNumber(contactUSDetails.customer_phone)
          ? contactUSDetails.customer_phone
          : "",
        query_text: contactUSDetails.customer_query,
      }),
    })
      .then((result) => result.json())
      .then((data) => {
        //check if success
        if (data.success === true) {
          //insert details in database
          contactQueryDetailsSubmitAPI(
            data.email_id,
            data.phone_number,
            data.reference_id
          );
        } else {
          //reset
          setSubmitContactUSClicked(false);
          //remove text
          setContactUSDetails({
            ...contactUSDetails,
            customer_name: "",
            customer_email: "",
            customer_phone: "",
            customer_query: "",
          });
        }
        console.log("Contact us form submitted: ", data);
      })
      .catch((error) => {
        //reset
        setSubmitContactUSClicked(false);
        //remove text
        setContactUSDetails({
          ...contactUSDetails,
          customer_name: "",
          customer_email: "",
          customer_phone: "",
          customer_query: "",
        });
      });

    console.log("Submit query form");
  };

  //insert query details to db
  const contactQueryDetailsSubmitAPI = async (
    email,
    phone_number,
    reference_id
  ) => {
    //get the access token from local storage
    var accessToken = localStorage.getItem("access_token");
    accessToken =
      accessToken !== null && accessToken !== "undefined" ? accessToken : "";

    //fetch the humanized text from the API
    await fetch(REQUEST_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // if needed
      },
      body: JSON.stringify({
        request_type: "INSERT_CONTACT_US_QUERY_PARAMS",
        email_id: email,
        phone_number: phone_number,
        reference_id: reference_id,
      }),
    })
      .then((result) => result.json())
      .then((data) => {
        //reset
        setSubmitContactUSClicked(false);
        //remove text
        setContactUSDetails({
          ...contactUSDetails,
          customer_name: "",
          customer_email: "",
          customer_phone: "",
          customer_query: "",
        });

        console.log("Successfully pushed details: ", data);
      })
      .catch((error) => {
        //reset
        setSubmitContactUSClicked(false);
        //remove text
        setContactUSDetails({
          ...contactUSDetails,
          customer_name: "",
          customer_email: "",
          customer_phone: "",
          customer_query: "",
        });
      });

    console.log("Submit contact us query details");
  };

  //submit newsletter email api call
  const newsLetterEmailAPI = async (emailID) => {
    //get the access token from local storage
    var accessToken = localStorage.getItem("access_token");
    accessToken =
      accessToken !== null && accessToken !== "undefined" ? accessToken : "";

    //fetch the humanized text from the API
    await fetch(REQUEST_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // if needed
      },
      body: JSON.stringify({
        request_type: "SUBMIT_NEWSLETTER_EMAIL",
        email_id: emailID,
      }),
    })
      .then((result) => result.json())
      .then((data) => {
        //reset
        setSubmitClicked(false);
        //remove text
        setEmailDetails({ ...emailDetails, emailID: "", isValidEmail: false });
      })
      .catch((error) => {
        //reset
        setSubmitClicked(false);
        //remove text
        setEmailDetails({ ...emailDetails, emailID: "", isValidEmail: false });
      });

    console.log("Submit newsletter email");
  };

  //return
  return (
    <div>
      <footer className="footer p-5 bg-light text-dark mt-5 ">
        <div className="row">
          <div className="col-lg-3 text-center"></div>

          {/* Footer Title */}
          <div className="col-lg-6 text-center mb-4">
            <div className="text-center mb-4">
              <h3 className="text-muted">Humanize Texts</h3>
              <p className="text-muted">
                Detect and transform AI-generated contents into human-like
                texts.
              </p>
            </div>

            {/* Footer Links */}
            <div className="container text-center mb-4">
              <Link to="/privacy-policy" className="text-muted mx-2">
                Privacy Policy
              </Link>
              <Link to="/terms-of-service" className="text-muted mx-2">
                Terms of Service
              </Link>
              <Link
                className="text-muted mx-2"
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
              >
                Contact us
              </Link>
            </div>

            {/* Copyright Content */}
            <div className="container">
              <p className="text-center text-muted">
                &copy; {new Date().getFullYear()} HumanizeTexts.com | All rights
                reserved.
              </p>
            </div>

            {/* Social Media Links */}
            <div className="container text-center">
              <button className="btn btn-social">
                <i className="bi bi-facebook"></i>
              </button>
              <button className="btn btn-social">
                <i className="bi bi-twitter"></i>
              </button>
              <button className="btn btn-social">
                <i className="bi bi-instagram"></i>
              </button>
            </div>
          </div>

          {/* Newsletter Signup */}
          <div className="col-lg-3 text-start">
            <h5 className="text-muted mt-4">Subscribe to our Newsletter</h5>
            <form
              className="d-flex justify-content-start"
              onSubmit={onSubmitNewsletterForm}
            >
              <input
                type="email"
                className="form-control me-3 mt-2"
                placeholder="Enter your email"
                onChange={onInputNewsletterEmailFieldChanged}
                value={emailDetails.emailID}
              />
              <button
                type="submit"
                className="btn btn-primary mt-2"
                disabled={
                  emailDetails.isValidEmail === false || submitClicked === true
                }
                onClick={(e) => {
                  //blur
                  e.currentTarget.blur();
                }}
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </footer>

      {/* Contact US Modal */}
      <div
        className="modal fade modal-fullscreen-lg-down"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Connect with Us
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {/* Full name */}
              <div className="mb-3">
                <label htmlFor="customer_name" className="form-label">
                  Full Name
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    contactUSValidity.isValidName ? "" : "border-danger"
                  }`}
                  id="customer_name"
                  placeholder="Alex Finch"
                  onChange={onContactUSFormValueChanged}
                  value={contactUSDetails.customer_name}
                />
              </div>

              {/* Email Address */}
              <div className="mb-3">
                <label htmlFor="customer_email" className="form-label">
                  Email address
                </label>
                <input
                  type="email"
                  className={`form-control ${
                    contactUSValidity.isValidEmail ? "" : "border-danger"
                  }`}
                  id="customer_email"
                  placeholder="alex123@gmail.com"
                  onChange={onContactUSFormValueChanged}
                  value={contactUSDetails.customer_email}
                />
              </div>

              {/* Phone number */}
              <div className="mb-3">
                <label htmlFor="customer_phone" className="form-label">
                  Phone number (optional)
                </label>
                <input
                  type="phone"
                  className="form-control"
                  id="customer_phone"
                  placeholder="+1-123-567-9870"
                  onChange={onContactUSFormValueChanged}
                  value={contactUSDetails.customer_phone}
                />
              </div>

              {/* Query */}
              <div className="mb-3">
                <label htmlFor="customer_query" className="form-label">
                  What do you have in mind?
                </label>
                <textarea
                  type="text"
                  className={`form-control ${
                    contactUSValidity.isValidQuery ? "" : "border-danger"
                  }`}
                  id="customer_query"
                  placeholder="Please enter query"
                  rows="3"
                  onChange={onContactUSFormValueChanged}
                  value={contactUSDetails.customer_query}
                ></textarea>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={(e) => {
                  //blur
                  e.currentTarget.blur();
                  //call
                  onSubmitContactUSForm();
                }}
                disabled={submitContactUSClicked}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
